
import { http } from "./api-config";

const apiClient = http(process.env.VUE_APP_AGENDA_SERVICE)
export default {
    async startTimer(timerData) {
        const res = await apiClient.post('orchestrators/FunctionOrchestrator', timerData)
        return res.data
    },

    async updateTimer(timerData) {
        const headers = { "isSilentAPI": false };
        const res = await apiClient.put('update_timer', timerData, { headers })
        return res.data.data
    },
    async saveTimer(timerData) {
        const res = await apiClient.put('save_timer', timerData)
        return res.data
    },
    async timerActions(timerData) {
        const { instance_id, event_name } = timerData
        const res = await apiClient.get(`timer_event/${instance_id}/${event_name}`)
        return res.data
    },
    async runDurableTaskWebHooks(timerData) {
        let originalUrl = String(process.env.VUE_APP_AGENDA_SERVICE);
        let baseUrl = originalUrl.replace("api/", "");
        const { instanceId, eventName, taskHub, connectionName, systemKey } = timerData
        const res = await fetch(
            `${baseUrl}runtime/webhooks/durabletask/instances/${instanceId}/raiseEvent/${eventName}?taskHub=${taskHub}&connection=${connectionName}&code=${systemKey}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({}),
            }
        );
        return res
    }
    // http://localhost:7071/api/timer_event/{instance_id}/{event_name}

}